import React, { useEffect, useState } from "react";
import {
  createMuiTheme,
  createStyles,
  makeStyles,
  Theme,
} from "@material-ui/core/styles";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import FormHelperText from "@material-ui/core/FormHelperText";
import FormControl from "@material-ui/core/FormControl";
import Select from "react-select";
import { Typography } from "@material-ui/core";
import { ThemeProvider } from "@material-ui/core";
import AddToListModal from "./FormGenerator/addToListModal";
import { TOGGLE_GROWING_LIST_POPUP } from "../Redux/actions";
import { useDispatch } from "react-redux";

const theme = createMuiTheme({
  overrides: {
    // root: {
    //     color: 'green',
    //     '& label.Mui-focused': {
    //         color: 'green',
    //     },
    //     '& .MuiInput-underline:after': {
    //         borderBottomColor: 'green',
    //     },
    //     '& .MuiOutlinedInput-root': {
    //         '& fieldset': {
    //             borderColor: 'red',
    //         },
    //         '&:hover fieldset': {
    //             borderColor: 'yellow',
    //         },
    //         '&.Mui-focused fieldset': {
    //             borderColor: 'green',
    //         },
    //     },
    // },
  },
});
const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      // color: 'green',
      // '& label.Mui-focused': {
      //     color: 'green',
      // },
      // '& .MuiInput-underline:after': {
      //     borderBottomColor: 'green',
      // },
      // '& .MuiOutlinedInput-root': {
      //     '& fieldset': {
      //         borderColor: 'red',
      //     },
      //     '&:hover fieldset': {
      //         borderColor: 'yellow',
      //     },
      //     '&.Mui-focused fieldset': {
      //         borderColor: 'green',
      //     },
      // },
    },
    basic_multi_select: {
      "& .css-1pahdxg-control": {
        borderColor: "#077F83",
        boxShadow: "0 0 0 1px #077F83 ",
        "&:focus": {
          borderColor: "#077F83",
        },
        "&:hover": {
          borderColor: "#077F83",
        },
      },
      "& .css-12jo7m5": {
        fontSize: 15,
        fontFamily: "Open Sans",
      },
      "& .css-1wa3eu0-placeholder": {
        fontSize: 16,
      },
      "& .css-yk16xz-control": {
        padding: "2px 0",

        "&:focus": {
          backgroundColor: "#077F83",
        },

        // '&:hover': {
        //     borderColor: "#077F83",
        // }
      },
    },
    basic_multi_select_error: {
      "& .css-yk16xz-control": {
        borderColor: "#f44336",
        // backgroundColor: "#077F83",
        "&:hover": {
          borderColor: "#077F83",
        },
      },
    },
    formControl: {
      width: "100%",
      borderColor: "#077F83",
    },
    whiteColor: {
      color: "red",
    },
  })
);
function CustomSelectMulti(props: any) {
  const classes = useStyles();
  const [selectedValue, setSelectedValue] = React.useState("");
  const [showModal, setShowModal] = useState(false);
  const [postData, setPostData] = useState({});
  const dispatch = useDispatch();
  const groupStyles = {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
  };
  const groupBadgeStyles: any = {
    backgroundColor: "#EBECF0",
    borderRadius: "2em",
    color: "#172B4D",
    display: "inline-block",
    fontSize: 12,
    fontWeight: "normal",
    lineHeight: "1",
    minWidth: 1,
    padding: "0.16666666666667em 0.5em",
    textAlign: "center",
  };

  const handleChange = (event: any) => {
    var localArr = [];
    localArr =
      event.length > 0 &&
      event.filter((option: any) => option.value == "+ Add New");
    if (localArr.length > 0) {
      // setShowModal(true)
      dispatch({ type: TOGGLE_GROWING_LIST_POPUP, payload: true });
      props.addNewHandler(props.addNewFlag, true, props);
    } else {
      props.parentcall(event, props.id);
    }
  };
  const formatGroupLabel = (data: any) => (
    <div style={groupStyles}>
      <span>{data.label}</span>
      <span style={groupBadgeStyles}>{data.options.length}</span>
    </div>
  );
  useEffect(() => {
    props.defaultValue != undefined && setSelectedValue(props.defaultValue);
    props.value != undefined && setSelectedValue(props.value);
  }, [props]);

  return (
    <FormControl
      variant={props.variant}
      className={classes.formControl}
      error={props.error}
    >
      <Select
        onChange={handleChange}
        {...props}
        isMulti
        name="colors"
        placeholder={<Typography variant="h2">{props.placeholder}</Typography>}
        options={props.itemArr}
        defaultValue={props.value}
        className={`${props.helperText && classes.basic_multi_select_error} ${
          classes.basic_multi_select
        }`}
        classNamePrefix="select"
        formatGroupLabel={props.grouped && formatGroupLabel}
      >
        {props.id != "partner_candidate_statuses" &&
          props.itemArr.map(
            (option: any) =>
              (option["label"] = (
                <Typography variant="h2">{option.value}</Typography>
              ))
          )}
      </Select>
      {props.addNewFlag && showModal && (
        <AddToListModal type="partner_profiles" postData={{ ...props }} />
      )}

      {props.helperText && <FormHelperText>{props.helperText}</FormHelperText>}
    </FormControl>
  );
}

export default CustomSelectMulti;
